export default "__VITE_PUBLIC_ASSET__7a62b122__"